const computed = {
  showBusinessesTag() {
    return this.dataBadges.some((data) => data.data === 'businesses');
  },
  getRoute() {
    return this.routeMenu ? this.routeMenu : this.route;
  },
  showModulesTag() {
    return this.dataBadges.some((data) => data.data === 'modules');
  },
  showSubcategoriesTag() {
    return this.dataBadges.some((data) => data.data === 'subcategories');
  },
};

export default computed;
